import { render, staticRenderFns } from "./AddOrderToBasketPrompt.vue?vue&type=template&id=0b531bc0&scoped=true"
import script from "./AddOrderToBasketPrompt.vue?vue&type=script&lang=js"
export * from "./AddOrderToBasketPrompt.vue?vue&type=script&lang=js"
import style0 from "./AddOrderToBasketPrompt.vue?vue&type=style&index=0&id=0b531bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b531bc0",
  null
  
)

export default component.exports